<template>
<ul class="Sidebar__level-1"
    :class="{jsExpanded:!collapsed}"
>
    <li class="Sidebar__level-1__item">
        <button class="Sidebar__level-1__heading"
                @click="toggleExpansion"
                :class="{jsExpanded:!collapsed}"
        >
            <span class="Sidebar__level-1__toggle">
                <i class="fas fa-caret-right"
                   v-if="collapsed"
                ></i>
                <i class="fas fa-caret-down"
                   v-else
                ></i>
            </span>
            <span class="Sidebar__level-1__title">
                {{ title }}
            </span>
            <span class="Sidebar__level-1__status"
                  v-if="icon"
                  :class="{jsComplete:complete}"
            >
                <i class="fas fa-check-circle"
                   v-if="complete"
                ></i>
                <i class="fas fa-minus-circle"
                   v-else
                ></i>
            </span>
        </button>
        <SidebarLevel2 v-if="!collapsed"
                       :items="items"
                       :sections="sections"
        ></SidebarLevel2>
    </li>
</ul>
</template>

<script>
import SidebarLevel2 from './SidebarLevel2';

export default {
    components: { SidebarLevel2 },
    props: [
        'id',
        'title',
        'icon',
        'items',
        'sections',
        'complete'
    ],

    data() {
        return {
            collapsed: true,
        };
    },

    mounted() {
        this.checkExpansion();
    },

    methods: {
        toggleExpansion() {
            this.collapsed = !this.collapsed;
            localStorage.setItem(this.id, this.collapsed);
        },

        checkExpansion() {
            if(!localStorage.getItem(this.id)) {
                return;
            }

            this.collapsed = localStorage.getItem(this.id) === 'true';
        }
    }
};
</script>
